import {
	__experimentalUnitControl as UnitControl,
	ToggleControl,
} from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import metadata from '../../block.json';

export default function NavigationControls( { attributes, setAttributes } ) {
	const handleChange = ( key, value ) => {
		setAttributes( {
			navigation: {
				...attributes.navigation,
				[ key ]: value,
			},
		} );
	};

	return (
		<>
			<ToggleControl
				__nextHasNoMarginBottom
				label={ __( 'Show arrows', 'brandy-blocks' ) }
				checked={ attributes.navigation?.enabled ?? true }
				onChange={ ( v ) => handleChange( 'enabled', v ) }
			/>
			{ ( attributes.navigation?.enabled ?? true ) && (
				<>
					<UnitControl
						label={ __(
							'Navigation button size',
							'brandy-blocks'
						) }
						onChange={ ( v ) => handleChange( 'size', v ) }
						value={
							attributes.navigation?.size ??
							metadata.attributes.navigation.default.size
						}
						units={ [
							{ value: 'px', label: 'px', default: 50 },
						] }
					/>
					<UnitControl
						label={ __(
							'Navigation arrow size',
							'brandy-blocks'
						) }
						onChange={ ( v ) => handleChange( 'iconSize', v ) }
						value={
							attributes.navigation?.iconSize ??
							metadata.attributes.navigation.default.iconSize
						}
						units={ [
							{ value: 'px', label: 'px', default: 7 },
						] }
					/>
				</>
			) }
		</>
	);
}
